module.exports = __webpack_public_path__ + "static/media/order(gray).e77068e9.svg";